<template>
  <custom-dialog width="50%" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body organ-device-dialog">
      <div class="item-title">{{ $t('base_organ_device_dialog.ji_qi_xin_xi') }}</div>
      <div class="info">
        <el-row>
          <el-col :span="8">
            <div class="item">
              <span>{{ $t('base_organ_device_dialog.chan_pin_xing_hao') }}</span>
              {{ item.productCode || '-' }}
            </div>
            <div class="item">
              <span>{{ $t('base_organ_device_dialog.ji_qi_ming_cheng') }}</span>
              {{ item.deviceName || '-' }}
            </div>
            <div class="item">
              <span>{{ $t('base_organ_device_dialog.shou_hou_gong_si') }}</span>
              {{ item.afterServiceName || '-' }}
            </div>
          </el-col>
          <el-col :span="8">
            <div class="item">
              <span>{{ $t('base_organ_device_dialog.ji_shen_hao') }}</span>
              {{ item.bodyNum || '-' }}
            </div>
            <div class="item">
              <span>{{ $t('base_organ_device_dialog.he_tong_bian_hao') }}</span>
              {{ item.contractNo || '-' }}
            </div>
            <div class="item">
              <span>{{ $t('base_organ_device_dialog.dai_li_gong_si') }}</span>
              {{ item.agentCoName || '-' }}
            </div>
          </el-col>
          <el-col :span="8">
            <div class="item">
              <span>{{ 'Modem SN' }}</span>
              {{ item.modemSn || '-' }}
            </div>
            <div class="item">
              <span>{{ $t('base_organ_device_dialog.xiang_mu_ming_cheng') }}</span>
              {{ item.locationName || '-' }}
            </div>
            <div class="item">
              <span>{{ $t('base_organ_device_dialog.zu_lin_fang') }}</span>
              {{ item.customerName || '-' }}
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="item-title">{{ $t('base_organ_device_dialog.xzbmyg') }}</div>
      <div class="bind">
        <div class="ub" style="padding: 0 8px 16px">
          <div class="left-box ub-f1" v-if="model.type !== 'watch'">
            <div class="tit">{{ $t('base_organ_device_dialog.yong_hu') }}</div>
            <div class="tree-box">
              <div class="tree">
                <el-tree
                  ref="tree"
                  check-strictly
                  show-checkbox
                  node-key="frontUnique"
                  :data="organTree"
                  :props="{
                    children: 'children',
                    label: 'bizName',
                    disabled: setDisabled,
                  }"
                  @check="checkChange"
                  :expand-on-click-node="false"
                  :default-expanded-keys="expandedKeys"
                  highlight-current
                >
                  <span class="tree-item" slot-scope="{ node, data }">
                    <i style="color: #f7b500" v-if="data.bizType === 3" class="icon icon-yonghu1"></i>
                    <i style="color: #00afff" v-else class="icon icon-zuzhi1"></i>
                    <span>{{ node.label }}</span>
                  </span>
                </el-tree>
              </div>
            </div>
          </div>
          <div class="right-box ub-f1">
            <div class="tit">{{ $t('base_organ_device_dialog.yxbmyg') }}</div>
            <div class="tree-box">
              <div class="tree" v-show="show">
                <el-tree
                  ref="tree1"
                  check-strictly
                  node-key="frontUnique"
                  :data="organTree"
                  :props="{ children: 'children', label: 'bizName' }"
                  :expand-on-click-node="false"
                  :default-expanded-keys="expandedKeys"
                  :filter-node-method="filterCheckNode"
                  highlight-current
                >
                  <span class="tree-item" slot-scope="{ node, data }">
                    <i style="color: #f7b500" v-if="data.bizType === 3" class="icon icon-yonghu1"></i>
                    <i style="color: #00afff" v-else class="icon icon-zuzhi1"></i>
                    <span>{{ node.label }}</span>
                  </span>
                </el-tree>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button v-if="model.type === 'edit'" @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button v-if="model.type === 'edit'" type="primary" @click="saveUpdate">{{ $t('Common.com_confirm') }}</el-button>
      <el-button v-else type="primary" @click="visible = false">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      item: {},
      organTree: [],
      expandedKeys: [],
      organUser: [],
      show: false,
      checkedKeys: [],
      checkedNodes: [],
    };
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 禁用状态
    setDisabled(data) {
      const list = data.children || [];
      return list.find((t) => this.checkedKeys.includes(t.bizId));
    },
    // 初始化
    initDialog: function () {
      this.getOrganTree();
      this.item = this.model.data;
    },
    // 获取组织
    getOrganTree: function () {
      this.$getJSON(apis.DepartmentTree, { isShowUsers: 1, orgId: this.model.data.orgId }).then((res) => {
        this.expandedKeys = [res.data.frontUnique];
        this.organTree = [res.data];
        this.$nextTick(() => {
          this.getDeviceOrgUser();
        });
      });
    },
    // 获取设备关联组织和用户
    getDeviceOrgUser: function () {
      this.$getJSON(`${apis.DeviceOrganUser}/${this.model.data.deviceId}`).then((res) => {
        const bindOrganUser = res.data || [];
        if (this.model.type === 'edit') {
          this.checkedKeys = bindOrganUser.map((t) => t.frontUnique);
          this.$refs.tree.setCheckedKeys(this.checkedKeys);
          this.$nextTick(() => {
            this.checkedNodes = this.$refs.tree.getCheckedNodes(false, true);
          });
        }
        this.$refs.tree1.filter(bindOrganUser);
        this.$nextTick(() => {
          this.show = true;
        });
      });
    },
    // 选中转换树
    checkChange: function (data, { checkedKeys }) {
      const selectPath = data.bizPath.split('/');
      selectPath.pop();
      this.checkedKeys = [...selectPath, ...checkedKeys]; // 包含所有选中的frontUnique
      this.$refs.tree.setCheckedKeys(this.checkedKeys);
      this.checkedNodes = this.$refs.tree.getCheckedNodes(false, true);
      this.$refs.tree1.filter(this.checkedNodes);
    },
    // 选中树过滤
    filterCheckNode(nodes, data) {
      return !!nodes.find((t) => t.frontUnique === data.frontUnique);
    },
    // 保存编辑
    saveUpdate: function () {
      const bizObjects = this.checkedNodes.map((t) => ({
        bizId: t.bizType === 3 ? t.userId : t.bizId,
        bizType: t.bizType,
        parentId: t.parentId,
        bizOrgId: this.model.data.orgId,
      }));
      this.$postJSON(
        apis.DevicebindAll,
        {
          bizList: bizObjects,
          deviceId: this.model.data.deviceId,
        },
        true
      ).then(() => {
        const msg = this.$t('Common.com_edit_success');
        this.$message({
          message: msg,
          type: 'success',
        });
        this.visible = false;
        this.$emit('success', this.form);
      });
    },
  },
};
</script>

<style lang="scss">
.organ-device-dialog {
  .title {
    color: #262626;
    font-size: 16px;
    line-height: 24px;
    padding-left: 10px;
    position: relative;
    .bar {
      left: 0;
      width: 4px;
      height: 15px;
      background: rgba(0, 175, 255, 1);
    }
  }
  .info {
    padding: 0 16px 16px;
    .item {
      font-size: 12px;
      color: #262626;
      line-height: 24px;
      span {
        color: #6e6e6e;
      }
    }
  }
  .tit {
    line-height: 40px;
    color: #262626;
    font-weight: bold;
    font-size: 13px;
    padding-left: 10px;
  }
  .left-box {
    display: flex;
    flex-direction: column;
    margin-right: 5px;
  }
  .right-box {
    display: flex;
    flex-direction: column;
    margin-left: 5px;
  }
  .tree-box {
    padding: 8px 11px;
    border: 1px solid #e4e4e4;
    height: 480px;
    overflow-y: auto;
  }
  .tree {
    height: 100%;
    overflow-y: auto;
    .tree-item {
      flex: 1;
      display: flex;
      align-items: center;
      font-size: 12px;
      padding-right: 8px;
      .icon {
        margin-right: 4px;
        font-size: 15px;
      }
      .el-checkbox__label {
        font-size: 12px;
      }
    }
  }
}
</style>
